import { Link } from "react-router-dom";
import { ROUTES } from "@/config/routes";
import { site } from "@/config/site";
import { FaqAccordion } from "@/features/public/components/FaqAccordion";
import { PublicPageShell } from "@/features/public/layout/PublicPageShell";

export function HelpPage() {
  return (
    <PublicPageShell
      eyebrow="Help"
      title="Help & support"
      lead="Quick answers and how to reach us."
      leadMuted={
        <>
          Step-by-step guides are in{" "}
          <Link to={ROUTES.docs} className="pub-inline-link">
            Docs
          </Link>
          .
        </>
      }
    >
      <div className="pub-help-grid">
        <div className="pub-help-card">
          <h2>Contact</h2>
          <p className="mb-3 text-sm text-[var(--text-secondary)]">
            Email us — typical reply within 1 business day.
          </p>
          <p className="mb-4 font-semibold text-[var(--accent)]">{site.supportEmail}</p>
          <a
            href={`mailto:${site.supportEmail}?subject=InvoiceVault%20support`}
            className="pub-btn pub-btn-primary w-full"
          >
            Send message
          </a>
        </div>
        <div className="pub-help-card">
          <h2>Quick links</h2>
          <p className="my-1 text-[0.8125rem]">
            <Link to={ROUTES.docs} className="pub-inline-link">
              Getting started → Docs
            </Link>
          </p>
          <p className="my-1 text-[0.8125rem]">
            <Link to={ROUTES.pricing} className="pub-inline-link">
              Plans → Pricing
            </Link>
          </p>
          <p className="my-1 text-[0.8125rem]">
            <Link to={ROUTES.legal} className="pub-inline-link">
              Privacy &amp; Terms → Legal
            </Link>
          </p>
        </div>
      </div>

      <h2 className="mb-2 text-sm font-semibold">Frequently asked questions</h2>
      <FaqAccordion />
    </PublicPageShell>
  );
}
